import { lazy } from 'react';

export function lazyWithRetry(importFn) {
  return lazy(() =>
    importFn().catch((error) => {
      if (
        error?.name === 'ChunkLoadError'
        || /Loading chunk .* failed/i.test(error?.message || '')
      ) {
        const key = 'chunk_reload_ts';
        const last = Number(sessionStorage.getItem(key) || 0);
        if (Date.now() - last > 8000) {
          sessionStorage.setItem(key, String(Date.now()));
          window.location.reload();
        }
      }
      throw error;
    })
  );
}
